






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { addDays } from 'date-fns';
import { oredersService } from '@/services';
import { Request, Users } from './types';

import { DatePicker } from '@/components/form';
import Button from '@/components/ext/Button.vue';
import Select from '@/components/form/Select.vue';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';

const isNull = (value: null | Date) => value === null;

@Component({
  components: {
    AppButtonNew,
    DatePicker,
    Button,
    Select,
  }
})
export default class RequestForm extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly users!: Users;

  @Prop({ type: Function })
  readonly nextStep!: Function;

  @Prop({ type: Object, default: null })
  readonly errors!: any;

  today: Date = new Date();
  request: Request = {
    dateStudyFrom: null,
    dateStudyTo: null,
    studentId: this.$store.state.user.profile.id,
    eduLevel: null,
  };

  get isDisabled() {
    const { dateStudyFrom, dateStudyTo, eduLevel } = this.request;
    return !eduLevel || !(isNull(dateStudyFrom) === isNull(dateStudyTo));
  }

  get eventOrderEduLevelsDict() {
    return this.$store.state.eventOrderEduLevelsDict.map((el: any) => ({
      value: el.id,
      text: el.name,
    }));
  }

  get fromDisabledDates() {
    const { request, today } = this;
    return { to: addDays(today, -1), from: request.dateStudyTo };
  }

  get toDisabledDates() {
    const { request, today } = this;
    return { to: request.dateStudyFrom || addDays(today, -1) };
  }

  async submitRequest() {
    const event_id: string = this.$store.state.event_card?.id || null;

    const tempValue = {
      ...this.request,
      students: [
        {
          id: this.request.studentId,
          edu_level: this.request.eduLevel,
        },
      ],
    };
    try {
      await oredersService(this.$axiosInstance).postOrderRequest({
        ...tempValue,
        event_id,
      });

      this.$emit('sendResult', {
        type: 'success',
      });
    } catch (err) {
      if (err.response.data) {
        const { errors } = err.response.data;
        let firstErrorMsg = null;
        const errorsArr = Array.isArray(errors)
          ? errors
          : Object.values(errors);
        if (errorsArr.length && errorsArr[0].errors) {
          firstErrorMsg = errorsArr[0].errors[0] || null;
        }

        this.$emit('sendResult', {
          type: 'error',
          text: {
            ...(firstErrorMsg &&
              firstErrorMsg.msg && { description: firstErrorMsg.msg }),
          },
        });
      }
    }
    this.nextStep();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/event/components/RequestForm.vue